module.exports = "/packs/016-ee34b507907e33111bcbb414a62a0814.jpg";